import script from "./Tinymce.vue?vue&type=script&setup=true&lang=js"
export * from "./Tinymce.vue?vue&type=script&setup=true&lang=js"

import "./Tinymce.vue?vue&type=style&index=0&id=6f6d927c&lang=scss&scoped=true"

import exportComponent from "D:\\Leo\\Frontend\\surveys\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6d927c"]])

export default __exports__